import React, { useEffect, useState } from 'react';

import styles from './CartPopup.module.css'
import { CartProduct } from "../ProductCard/types/productCard.interface.ts";
import { Button } from "../../ui/General/Button/Button.tsx";
import { AmountAdjustment } from "../AmountAdjustment/AmountAdjustment.tsx";
import { cn } from "../../utils/cn.ts";
import { Icon } from "../../ui/General/Icon/Icon.tsx";
// import { useMultiStorage } from '../../hooks/useStorage.ts';
import { API_URL } from '../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setAddedCartElement } from '@/utils/storage/slices/cartSlice.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';

interface Props {
    product: CartProduct,
}
type ProductOperation = 'add' | 'remove'

export const CartPopup: React.FC<Props> = ({ product }) => {
    const dispatch = useAppDispatch();
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    const [elementAmount, setElementAmount] = useState<number>(product.amount);
    const [elementStock, setElementStock] = useState<number>(product.stock);
    // const [storage, setStorage] = useMultiStorage({
    //     getCartOffer: ['getCartOffer', false],
    // });

    useEffect(() => {
        setElementAmount(product.amount);
    }, [product]);

    const { id, price, name, productId, img, brand } = product;

    /** Закрытие попапа */
    const close = () => {
        dispatch(setAddedCartElement(null));
    };

    const addOrLessenProduct = (elementId: number, operation: ProductOperation) => {
        fetch(`${API_URL}/cart_element/${elementId}/change_amount`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ operation }),
        })
            .then(() => dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true})))
            .then(() => {
                let newElementAmount = elementAmount;
                let newElementStock = elementStock;
                if (operation === 'add') {
                    newElementAmount++;
                    newElementStock--;
                }
                else {
                    newElementAmount--;
                    newElementStock++;
                }
                setElementAmount(newElementAmount);
                setElementStock(newElementStock);
            })
    }

    return (<>
        <div className={cn(styles.wrapper)}>
            <div
                className={styles.closeBtn}
                onClick={(e) => {
                    e.stopPropagation()
                    close()
                }}>
                <Icon
                    name='close'
                    width={20}
                    height={20}
                />
            </div>
            <h3 className={styles.title}>
                Добавлено в корзину
            </h3>
            <ul className={styles.products}>
                <li className={styles.product}>
                    <div className={styles.infoWrapper}>
                        <img className={styles.img} src={img} alt={'Изображение ' + name} />
                        <div className={styles.info}>
                            <div>
                                <span className={styles.brand}>{brand}</span> {productId}
                            </div>
                            <div>{name}</div>
                        </div>
                    </div>
                    <div className={styles.counter}>
                        <div className={styles.amountAdjustment}>
                            <AmountAdjustment
                                amount={elementAmount}
                                up={() => { if (elementAmount < elementStock) addOrLessenProduct(id, 'add') }}
                                down={() => { if (elementAmount > 1) addOrLessenProduct(id, 'remove') }}
                            />
                        </div>
                        <div className={styles.price}>
                            {price} ₽
                        </div>
                    </div>
                    <div className={styles.hint}>
                        В наличии {elementStock} шт.
                    </div>
                    <div className={styles.buttons}>
                        <Button className={styles.btnToShopping} type='text' onClick={close} id='continue-shopping-btn'>
                            Продолжить покупки
                        </Button>
                        <Button className={styles.btnToCart} type='regular' onClick={() => { close();document.location = '/cart'; }} id='go-to-cart-btn'>
                            Перейти в корзину
                        </Button>
                    </div>
                </li>
            </ul>
        </div>
    </>);
};
